module.exports = __webpack_public_path__ + "static/img/service-small.94d09ac.jpg";